import React from "react"

import {MC} from "../client/MC.js"
import {Value} from "../client/Value.js"
import {Widget} from '../client/Widget.jsx'
import {FieldDef} from "./FieldDef.js"
import {WidgetModel} from "./WidgetModel.js"
import {GetText} from "./GetText.js"
import {Modeler} from "./Modeler.jsx"

class Palette extends React.Component {

  state = {search: ""}
  searchInputRef = React.createRef()
  rootRef = React.createRef()

  handleSearchChange = (event) => {
    this.setState({search: event.target.value})
  }

  handleClick = (event) => {
    event.preventDefault()
  }

  componentDidMount() {
    if (!this.props.widgetModelLoaded) {
      return
    }
    this.searchInputRef.current.focus()
    Modeler.setHeight(this.rootRef.current.querySelector('.inner'))
  }

  render() {
    if (!this.props.widgetModelLoaded) {
      return <div><div className="mnc loader"></div></div>
    } else {
      const param = {"@titlePlacement": "UL", "@helpDisplay": "none"}
      let labelField = {"widget":"label", "grid": [{"columns":"12","index":"1","offset":"0","resolution":"x-small","visible":"true","newLineAfter":"never"}], "fields": [], "param": MC.mconf.typedParam ? Value.fromJson(param) : param}
      let fields = []
      let fieldsPalette = WidgetModel.getFieldsPalette(this.props.flow)
      let fieldsDef = fieldsPalette.filter(field => MC.getFieldParamValue(field.param, "@title").toUpperCase().includes(this.state.search.toUpperCase()))
      for (let field of fieldsDef) {
        let displayedField = MC.extend({}, labelField)
        displayedField.id = field.id
        MC.putFieldParamValue(displayedField.param, "@title", MC.getFieldParamValue(field.param, "@title"))
        if (-1 != ["repeater", "table"].indexOf(field.widget)) {
          field.fields = [{id: "rows*", fields: [], flow: this.props.flow, rbsid: "dummy-rows", widget: "dummy", param: {}}]
        }
        field.flow = this.props.flow
        displayedField.flow = this.props.flow
        displayedField.isInPalette = true
        FieldDef.setProto(displayedField)
        fields.push(<div key={field.widget} style={{flex: '0 0 calc(50% - 1px)', margin: '0px', paddingTop: '0px', paddingBottom: '0px', boxShadow: 'none', border: 'none', borderRadius: 0}}><Widget widget={displayedField} resolution="x-small"/></div>)
      }
      return <div ref={this.rootRef} style={{top: this.props.y, right: 0, position: 'absolute', width: '404px', zIndex: 100000, background: 'var(--mnc-surface-container-lowest-color)', border: '1px solid var(--mnc-outline-variant-color)'}} onClick={this.handleClick}>
              <div style={{borderBottom: '1px solid var(--mnc-outline-variant-color)'}}>
                <div className="mnc icon input" style={{padding: '5px', flexGrow: 1}}>
                  <input ref={this.searchInputRef} name="widgetsearch" type="text" placeholder={GetText.t("Search...")} onChange={this.handleSearchChange}/>
                    <i className="search icon"/>
                  </div>
                </div>
                <div style={{display: 'flex', flexWrap: 'wrap', gap: '2px', width: '404px', padding: '5px', overflowY: 'auto', overscrollBehavior: 'none'}} className="inner">
                  {fields}
                </div>
            </div>
      }
  }
}

export {Palette}